import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=b218f4b8&scoped=true"
import script from "./panel.vue?vue&type=script&lang=js"
export * from "./panel.vue?vue&type=script&lang=js"
import style0 from "./panel.vue?vue&type=style&index=0&id=b218f4b8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b218f4b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b218f4b8')) {
      api.createRecord('b218f4b8', component.options)
    } else {
      api.reload('b218f4b8', component.options)
    }
    module.hot.accept("./panel.vue?vue&type=template&id=b218f4b8&scoped=true", function () {
      api.rerender('b218f4b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/panel.vue"
export default component.exports